const AUTH_PATHS = {
  AUTH: "/auth/",
  LOGIN: "login",
  RESET_PASSWORD: "reset-password",
  NEW_PASSWORD: "new-password",
  TWO_FACTOR: "two-factor",
};

export { AUTH_PATHS };
